import React, { Fragment } from 'react';
import { Text, View } from '@react-pdf/renderer';
import intl from 'react-intl-universal';
import { styles } from '../styles';
import PropTypes from 'prop-types';

const propTypes = {
  invoicePaymentMethod: PropTypes.string.isRequired,
};

const InvoicePaymentMethod = ({ invoicePaymentMethod }) => {
  return (
    <Fragment>
      <View style={styles.invoicePaymentMethod}>
        <Text style={styles.invoicePaymentMethodTitle}>
          {intl.get('billing_invoice_text_transfer_destination')}
        </Text>
        <Text style={styles.invoicePaymentMethodText}>
          {invoicePaymentMethod}
        </Text>
      </View>
    </Fragment>
  );
};

InvoicePaymentMethod.propTypes = propTypes;

export default InvoicePaymentMethod;
